import httpHelper from "@/helpers/httpHelper";
// action types 
export const INTER_BANK_PAYMENT = "interBankPeaymeny";
// mutation types
// export const SET_BANK_LIST = "setBankList";

export default {
    state: {
        // BankList: [],

    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        // loadedBankList(state) {
        //     return state.BankList;
        // },


    },
    actions: {
        /**
         * Set the BankList 
         * @param state
         * @param payload
         */
        [INTER_BANK_PAYMENT](context, payload) {

            return new Promise((resolve, reject) => {
                httpHelper
                    .postData('internaltransfer', payload)
                    .then((response) => {
                        // context.commit(SET_BANK_LIST, options);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
    },
    // mutations: {

    //     [SET_BANK_LIST](state, payload) {
    //         state.BankList = payload;
    //     },

    // }
};